import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { eventQueryOptionsV4 } from 'hooks/api/event'
import { canViewAnalyticsPermission } from 'hooks/usePermission'
import { DateTime } from 'luxon'

/**
 * Deprecated visitor-history tab. The standalone view was replaced by a prefiltered events search,
 * but the route is kept so existing links keep working: we resolve the event's visitor id and
 * redirect to the identification events page filtered to that visitor over the last 7 days.
 */
export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/visitor-history'
)({
  beforeLoad: (ctx) => protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx),
  loader: async ({ context: { buildRequest, queryClient }, params: { subscriptionId, requestId } }) => {
    let visitorId: string | undefined
    try {
      const event = await queryClient.ensureQueryData(eventQueryOptionsV4(buildRequest, subscriptionId, requestId))
      visitorId = event?.identification?.visitor_id
    } catch {
      // Event could not be resolved (e.g. not found) — fall back to an unfiltered events redirect.
    }

    const now = DateTime.now().startOf('minute')

    throw redirect({
      to: AppRoute.IdentificationEvents,
      params: { subscriptionId },
      replace: true,
      ...(visitorId
        ? {
            search: {
              visitorId,
              since: now.minus({ days: 7 }).toISO() ?? undefined,
              before: now.toISO() ?? undefined,
            },
          }
        : {}),
    })
  },
})
